import React, { useEffect, useState } from 'react';
import { useHttp } from '@veda/dashboard-ui';

function InfoRow({ label, value }) {
  if (!value) return null;
  return (
    <div className="flex flex-col sm:flex-row sm:items-center py-3 border-b border-gray-100 dark:border-gray-700 last:border-0">
      <dt className="w-48 text-sm font-medium text-gray-500 dark:text-gray-400 flex-shrink-0">{label}</dt>
      <dd className="text-sm text-gray-800 dark:text-white mt-1 sm:mt-0">{value}</dd>
    </div>
  );
}

const AUTH_PROVIDER_LABEL = {
  spid:  'SPID',
  cie:   'CIE — Carta d\'Identità Elettronica',
  eidas: 'eIDAS',
  email: 'Email + Password',
};

export default function OperatoreProfilo() {
  const { request } = useHttp();
  const [profilo, setProfilo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    request('/api/v1/operatore/me', {
      method: 'get',
      onSuccess: (data) => { setProfilo(data); setLoading(false); },
      onFormError: () => setLoading(false),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
      </div>
    );
  }

  const op      = profilo?.operatore;
  const company = profilo?.company;

  return (
    <div className="max-w-2xl mx-auto p-6">

      <div className="flex items-center gap-4 mb-8">
        <div className="w-14 h-14 rounded-full bg-blue-100 dark:bg-blue-900 flex items-center justify-center text-blue-600 dark:text-blue-300 text-2xl font-bold flex-shrink-0">
          {(company?.ragione_sociale ?? profilo?.name ?? 'O')[0].toUpperCase()}
        </div>
        <div>
          <h1 className="text-xl font-bold text-gray-800 dark:text-white">
            {company?.ragione_sociale ?? profilo?.name}
          </h1>
          <span className="inline-block mt-1 px-2 py-0.5 text-xs font-medium bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-300 rounded">
            Operatore Economico
          </span>
          {op?.auth_provider && (
            <span className="ml-2 inline-block px-2 py-0.5 text-xs font-medium bg-green-100 text-green-700 dark:bg-green-900 dark:text-green-300 rounded">
              {AUTH_PROVIDER_LABEL[op.auth_provider] ?? op.auth_provider}
            </span>
          )}
        </div>
      </div>

      {company ? (
        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm p-6 mb-4">
          <h2 className="text-base font-semibold text-gray-700 dark:text-gray-200 mb-4">Dati aziendali</h2>
          <dl>
            <InfoRow label="Ragione sociale"       value={company.ragione_sociale} />
            <InfoRow label="Codice fiscale"        value={company.codice_fiscale} />
            <InfoRow label="Partita IVA"           value={company.partita_iva} />
            <InfoRow label="Rappresentante legale" value={company.rappresentante_legale} />
            <InfoRow label="Email"                 value={company.email ?? profilo?.email} />
            <InfoRow label="PEC"                   value={company.pec} />
            <InfoRow label="Metodo di accesso"     value={AUTH_PROVIDER_LABEL[op?.auth_provider] ?? op?.auth_provider} />
          </dl>
        </div>
      ) : (
        <div className="bg-amber-50 dark:bg-amber-900/20 rounded-xl p-4 text-sm text-amber-700 dark:text-amber-300 border border-amber-200 dark:border-amber-700 mb-4">
          <p className="font-medium mb-1">Profilo aziendale non ancora creato</p>
          <p>Vai su <strong>Profilo aziendale</strong> nel menu per registrare la tua azienda e iniziare a presentare proposte PPP.</p>
        </div>
      )}

    </div>
  );
}
